import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { BookmarkStore, BookmarkState } from './bookmark.store.js';
// import { BookmarkStore, BookmarkState, BookmarkUIState } from './bookmark.store';

@Injectable({ providedIn: 'root' })
export class BookmarkQuery extends QueryEntity<BookmarkState> {
  // override ui!: EntityUIQuery<BookmarkUIState>;
  constructor(protected override store: BookmarkStore) {
    super(store);
    // this.createUIQuery();
  }
}
